const contextEnrichment = ({
    currency,
    isTouch,
    pageCtxId,
    boxClass,
    carouselPosition
}) => ({
    impressionEnrichment: {
        listings: {
            carousel_position: carouselPosition.toString(),
            page_ctx_id: pageCtxId
        }
    },
    context: {
        sourcePage: 'guest_homepage',
        sourceComponent: boxClass,
        currency,
        pageCtxId,
        queryParameters: {
            context: 'recommendation'
        },
        viewportType: 'homepage.logged_out',
        controllerAction: 'homepage#logged_out'
    },
    isTouch
});

export default contextEnrichment;
